import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constant } from '../common/constant';
import { ChatContact, ChatConversation, ChatMessage } from '../views/chat/models';

@Injectable()
export class ChatApiService {

    constructor(private readonly http: HttpClient) {
    }

    startDirectChat(otherUserId: number) {
        const url = Constant.REST_URL + Constant.CHAT + Constant.START_DIRECT_CHAT;
        return this.http.post<ChatConversation>(url, { otherUserId });
    }

    getMyConversations() {
        const url = Constant.REST_URL + Constant.CHAT + Constant.GET_MY_CONVERSATIONS;
        return this.http.get<ChatConversation[]>(url);
    }

    getContacts() {
        const url = Constant.REST_URL + Constant.CHAT + Constant.GET_CHAT_CONTACTS;
        return this.http.get<ChatContact[]>(url);
    }

    getMessages(conversationId: number, page: number = 0, size: number = 30) {
        const url = Constant.REST_URL + Constant.CHAT + Constant.GET_MY_CONVERSATIONS
            + '/' + conversationId + '/messages?page=' + page + '&size=' + size;
        return this.http.get<ChatMessage[]>(url);
    }

    postReceipt(conversationId: number, upToMessageId: number, read: boolean) {
        const url = Constant.REST_URL + Constant.CHAT + Constant.GET_MY_CONVERSATIONS
            + '/' + conversationId + '/receipt?read=' + read;
        return this.http.post(url, { upToMessageId });
    }
}
